import { Avatar, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';
import ColorHelper from "../../../../../../common/helpers/color/ColorHelper";
import colors from "../../../../../../common/styles/colors";
import { darken } from "@mui/material/styles";
import clsx from "clsx";

type Props = {
  name: string;
  onClick?: () => void;
  className?: string;
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    width: "100%"
  },
  name: {
    marginLeft: 8,
    fontWeight: "normal"
  },
  cursorPointer: {
    "&:hover": {
      cursor: "pointer"
    }
  }
});

export const UserWithAvatar = ({ name, onClick, className }: Props) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.container, onClick && classes.cursorPointer)} onClick={onClick}>
      <Avatar
        sx={{
          width: 26,
          height: 26,
          fontSize: "12px",
          bgcolor: darken(ColorHelper.stringToColor(name), 0.3),
          color: colors.white
        }}
      >
        {name[0]}
      </Avatar>
      <span className={clsx(classes.name, className)}>{name}</span>
    </Box>
  );
};
